import React from 'react'

import { useTranslation } from 'react-i18next'
import { MethodSelectorContainer, MethodsBar, MethodContainer } from './ImplementTag.styled'
import { StyledText } from '@clickcease/cc-client-components-lib'
import {
  GetTagMethods,
  SmallGetTagMethodIcons,
  GetTagMethod,
  GetTagMethodIcons,
} from './MethodSelector.models'
import { GoogleTagManagerIcon } from 'Assets/icons/GoogleTagManagerIcon'

export const MethodsSelector = ({
  onSelect,
  selectedMethod,
  addedDomainAddress,
  smallIcons,
}: {
  addedDomainAddress: string
  selectedMethod: GetTagMethod
  onSelect: (m: GetTagMethod) => void
  smallIcons?: boolean
}) => {
  const { t } = useTranslation('onboarding')
  const googleTagManager = 'googleTagManager'
  const methodIcons = smallIcons ? SmallGetTagMethodIcons : GetTagMethodIcons

  return (
    <MethodSelectorContainer>
      <StyledText variant={'largeBold'} css={{ marginRight: '$8' }}>
        {t('setUpTag.selectCTA', { domainAddress: addedDomainAddress })}
      </StyledText>
      <MethodsBar>
        {GetTagMethods.map((method) => (
          <MethodContainer
            onClick={() => onSelect(method)}
            selected={method === selectedMethod}
            key={method}
            isSmall={smallIcons}
          >
            {method === googleTagManager && selectedMethod === method ? (
              <GoogleTagManagerIcon width={smallIcons ? 24 : 49} height={smallIcons ? 24 : 48} />
            ) : (
              methodIcons[method]
            )}
            <StyledText variant={'baseLight'} css={{ textAlign: 'center' }}>
              {t(`setUpTag.${method}`)}
            </StyledText>
          </MethodContainer>
        ))}
      </MethodsBar>
    </MethodSelectorContainer>
  )
}
